import { ageBandsOf } from "@greg-chick/shared";

/**
 * 👶 **몇 살 것인지 — 작은 딱지 줄** (2026-10-02, 조치계획서 ■9 「첫 화면과 책 소개에 연령 명시」).
 *
 * 첫 화면 제목 아래와 책 고르기 화면에 같은 조각을 쓴다. 나누는 판정은 shared `ageBandsOf` 한 곳 —
 * 관리자 미리보기도 같은 함수를 쓴다(화면마다 다시 짜면 조용히 갈린다).
 * 운영자가 칸을 비우면 아무것도 안 그린다(빈 줄도 안 남긴다).
 */
export function AgeBands({ text, className }: { text: string; className?: string }) {
  const bands = ageBandsOf(text);
  if (bands.length === 0) return null;
  return (
    <ul className={`agebands${className ? ` ${className}` : ""}`} aria-label="몇 살에 무엇을">
      {bands.map((b) => (
        <li key={b} className="agebands__chip">
          {b}
        </li>
      ))}
    </ul>
  );
}
